'use strict';

/**
 * Canonical dropdown/parameter registry for the Search Filter Form.
 *
 * Maps each supported dropdown to the form input it populates (`dropdownType`, i.e. the
 * input `name`) and how it behaves (single- vs multi-select). The `specialty` entry also
 * carries the regex patterns used to recover specialty values from a raw query string
 * when they can't be read from URLSearchParams directly.
 *
 * This is the single source of truth for the shared dropdown metadata. `URLManager`
 * (managers/url.js) reads it for URL param handling, and `DropdownTriggerManager`
 * (managers/dropdown-trigger.js) derives its input names / single-select flags from it
 * so the two never drift.
 *
 * Kept separate from `config.js` (DOM selectors / CSS classes) because this describes
 * dropdown/param domain data rather than markup.
 */
export const PARAMETER_CONFIG = {
	state: {
		paramName: 'state',
		dropdownType: 'states-options',
		singleSelect: true,
	},
	insurance: {
		paramName: 'insurance',
		dropdownType: 'payors-options',
		singleSelect: true,
	},
	typeOfCare: {
		paramName: 'typeOfCare',
		dropdownType: 'type-of-care-options',
		singleSelect: true,
	},
	specialty: {
		paramName: 'specialty',
		dropdownType: 'specialties-options',
		singleSelect: false,
		patterns: [
			/specialty\[(\d+)\]/g,
			/specialty=([^&]+)/g,
			/Specialty=([^&]+)/g,
			/SPECIALTY=([^&]+)/g,
		],
	},
};
